<template>
  <div class="card copy-button" @click="clickHandler">
    <div class="leftPart">
      <div class="date">
        {{ date }}
      </div>
      <div>
        <img :src="travelConfig.icon" alt="" class="icon">
        <div class="type">
          {{ travelConfig.name }}
        </div>
      </div>
    </div>
    <div class="rightPart">
      <div class="label">
        有肺炎患者乘坐
      </div>
      <img :src="imageMap.arrow" alt="" class="arrow">
      <div class="grayText">
        {{ travelConfig.title }}
      </div>
      <div class="bigText">
        {{ cardInfo.tripNo }}
      </div>
      <div class="row">
        <div class="grayText">
          {{ travelConfig.departText }}
        </div>
        <div class="grayText">
          {{ travelConfig.arriveText }}
        </div>
      </div>
      <div class="row">
        <div class="blackText">
          {{ cardInfo.tripDepname }}
        </div>
        <div class="blackText">
          {{ cardInfo.tripArrname }}
        </div>
      </div>
      <div class="row">
        <div class="blackText">
          {{ formatDate( cardInfo.tripDeptime ) }}
        </div>
        <div class="blackText">
          {{ formatDate( cardInfo.tripArrtime ) }}
        </div>
      </div>
      <div class="publisher" v-if="showPublisher">
        消息来源：{{ cardInfo.publisher }}
      </div>
    </div>
  </div>
</template>

<script>
  import travelConfig from '../../travel-config.js';
  import imageMap     from '../../image-map.js';
  import env          from '@/utils/env.js';
  // import clipboard    from '@/utils/clipboard.js';

  // let urlClipboard;

  // urlClipboard = null;

  export default {
    props : [ 'cardInfo' ],

    data() {
      return { imageMap };
    },

    computed : {
      date() {
        let result;

        if ( this.cardInfo ) {
          result = this.cardInfo.tripDate.split( '-' );
          result.shift();
          result = result.join( '/' );
        }

        return result;
      },

      travelConfig() {
        let result;

        if ( this.cardInfo ) {
          result = travelConfig[ this.cardInfo.tripType ];
        } else {
          result = {};
        }

        return result;
      },

      showPublisher() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'xiaomi';
      }
    },

    methods : {
      formatDate( date ) {
        let result, datePart, timePart;

        date = date.split( ' ' );

        datePart = date[ 0 ].split( '-' );
        datePart.shift();
        datePart = datePart.join( '/' );

        timePart = date[ 1 ].split( ':' );
        timePart.pop();
        timePart = timePart.join( ':' );

        result = [ datePart, timePart ].join( ' ' );

        return result;
      },

      clickHandler() {
        let url;

        localStorage.setItem(
          'virusTripStore', JSON.stringify( this.$store.state )
        );

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        if ( this.cardInfo.tripType === 'flight' ) {
          if ( env.isWeixinMiniProgram ) {
            url = 'https://2019ncov.133.cn';
          } else {
            url = 'https://h5.133.cn';
          }

          url = `${
            url
          }/hangban/vue/dynamic/details-lite?no=${
            this.cardInfo.tripNo
          }&dep=${
            this.cardInfo.tripDepcode
          }&arr=${
            this.cardInfo.tripArrcode
          }&date=${
            this.cardInfo.tripDate
          }&id=${
            this.cardInfo.id
          }&t=${
            ( new Date() ).getTime()
          }${
            ptid ? '&ptid=' + ptid : ''
          }`;

          location.href = url;
        } else if ( this.cardInfo.tripType === 'train' ) {
          url = `https://2019ncov.133.cn/virus-trip/Vue/sariTrip/detail?departDate=${
            this.cardInfo.tripDate
          }&trainNo=${
            this.cardInfo.tripNo
          }&id=${
            this.cardInfo.id
          }&t=${
            ( new Date() ).getTime()
          }${
            ptid ? '&ptid=' + ptid : ''
          }`;

          location.href = url;
        } else {
          url = `https://2019ncov.133.cn/virus-trip/Vue/coronavirus/details?id=${
            this.cardInfo.id
          }${
            ptid ? '&ptid=' + ptid : ''
          }`;

          location.href = url;
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./card.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/card.vue